export const getters = {
	isInfoboxVisible(state, otherGetters, { user }) {
		return !user.profile.flags.includes('web_tracking_msg');
	},

	isTrackingActive({ counters }) {
		return counters.totalEvents > 0;
	}
};
